import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { Button } from 'antd';
import React from 'react';
import { CourseLineProvider } from '../context';
import { CourseLineTable } from './List/CourseLineTable';
import { DetailCourseLine } from './Form';
import { Authorize } from '@/core';
import { PERMISSIONS } from '@/contants';

export const CourseLineScreen: React.FC<unknown> = () => {
  const { open, handleClose, setOpen, handleClickCreate } = useHandleActionItem();

  return (
    <>
      <CourseLineProvider>
        <div className='bg-white py-4 px-4 flex flex-col flex-wrap'>
          <div className='ml-auto'>
            <Button
              type='primary'
              size='middle'
              onClick={() => handleClickCreate()}
              className='rounded'
            >
              + Create
            </Button>
          </div>
          <div className='w-full mt-2'>
            <CourseLineTable />
            <DetailCourseLine open={open} handleClose={handleClose} setOpen={setOpen} />
          </div>
        </div>
      </CourseLineProvider>
    </>
  );
};

export const CourseLineList = Authorize<unknown>(CourseLineScreen, PERMISSIONS.COURSE_LINES.VIEW);
